import { createApiInstance } from "./apiClient";

const url = process.env.REACT_APP_ORDER_API_URL;

const failureFromError = (error) => {
	const status = error.response?.status;
	const carriesDisplayMessage = status === 400 || status === 409;

	return {
		error: true,
		success: false,
		status,
		invalid: status === 400,
		conflict: status === 409,
		message: carriesDisplayMessage
			? error.response?.data?.errors?.[0]?.message
			: null
	};
};

export const getPaymentData = async (paymentId) => {
	try {
		const instance = createApiInstance({ baseURL: `${url}/api/payment/`, retry: true });

		const requestUrl = `${paymentId}`;

		return await instance
			.get(requestUrl)
			.then((response) => {
				if (response.status === 200)
					return {
						error: false,
						success: true,
						message: response.data.message,
						data: response.data.data
					};
				else
					return {
						error: true,
						success: false,
						message: response.data.message
					};
			})
			.catch((error) => {
				if (error.response) {
					console.error("Server Error:", error.response.status);
				}
				else if (error.request) {
					console.error("Network Error:", error.request);
				}
				else {
					console.error("Error:", error.message);
				}

				return failureFromError(error);
			});
	}
	catch (e) {
		return {
			error: true,
			success: false,
			message: "Something went wrong. Please try again."
		};
	}
};

export const getAvailablePaymentMethods = async () => {
	try {
		const instance = createApiInstance({ baseURL: `${url}/api/payment/`, retry: true });

		const requestUrl = `methods`;

		return await instance
			.get(requestUrl)
			.then((response) => {
				if (response.status === 200)
					return {
						error: false,
						success: true,
						message: response.data.message,
						data: response.data.data
					};
				else
					return {
						error: true,
						success: false,
						message: response.data.message
					};
			})
			.catch((error) => {
				if (error.response) {
					console.error("Server Error:", error.response.status);
				}
				else if (error.request) {
					console.error("Network Error:", error.request);
				}
				else {
					console.error("Error:", error.message);
				}
			});
	}
	catch (e) {
		return {
			error: true,
			success: false,
			message: "Something went wrong. Please try again."
		};
	}
};

export const postPayment = async (paymentData) => {
	try {
		const instance = createApiInstance({ baseURL: `${url}/api/payment/`, retry: true });

		const body = {
			paymentId: paymentData.paymentId,
			orderId: paymentData.orderId,
			amount: paymentData.amount,
			paymentTypeId: paymentData.type,
			paymentStatusId: paymentData.status
		};

		return await instance
			.post(``, body)
			.then((response) => {
				if (response.status === 200 || response.status === 204)
					return {
						error: false,
						success: true
					};
				else
					return {
						error: true,
						success: false,
						message: response.data.message
					};
			})
			.catch((error) => {
				if (error.response) {
					console.error("Server Error:", error.response.status);
				}
				else if (error.request) {
					console.error("Network Error:", error.request);
				}
				else {
					console.error("Error:", error.message);
				}
			});
	}
	catch (e) {
		return {
			error: true,
			success: false,
			message: "Something went wrong. Please try again."
		};
	}
};

export const postAccountCreditPayment = async () => {
	try {
		const instance = createApiInstance({ baseURL: `${url}/api/payment/`, retry: true });

		return await instance
			.post(`account-credit`)
			.then((response) => {
				if (response.status === 204)
					return {
						error: false,
						success: true,
						message: response.data.message,
						data: response.data.data
					};
				else
					return {
						error: true,
						success: false,
						message: response.data.message
					};
			})
			.catch((error) => {
				if (error.response) {
					console.error("Server Error:", error.response.status);
				}
				else if (error.request) {
					console.error("Network Error:", error.request);
				}
				else {
					console.error("Error:", error.message);
				}

				return failureFromError(error);
			});
	}
	catch (e) {
		return {
			error: true,
			success: false,
			message: "Something went wrong. Please try again."
		};
	}
};

export const postEftPayment = async () => {
	try {
		const instance = createApiInstance({ baseURL: `${url}/api/payment/`, retry: true });

		return await instance
			.post(`eft`)
			.then((response) => {
				if (response.status === 204)
					return {
						error: false,
						success: true,
						message: response.data.message,
						data: response.data.data
					};
				else
					return {
						error: true,
						success: false,
						message: response.data.message
					};
			})
			.catch((error) => {
				if (error.response) {
					console.error("Server Error:", error.response.status);
				}
				else if (error.request) {
					console.error("Network Error:", error.request);
				}
				else {
					console.error("Error:", error.message);
				}

				return failureFromError(error);
			});
	}
	catch (e) {
		return {
			error: true,
			success: false,
			message: "Something went wrong. Please try again."
		};
	}
};

export const postCreditCardOnCollectionPayment = async () => {
	try {
		const instance = createApiInstance({ baseURL: `${url}/api/payment/`, retry: true });

		return await instance
			.post(`credit-card-on-collection`)
			.then((response) => {
				if (response.status === 204)
					return {
						error: false,
						success: true,
						message: response.data.message,
						data: response.data.data
					};
				else
					return {
						error: true,
						success: false,
						message: response.data.message
					};
			})
			.catch((error) => {
				if (error.response) {
					console.error("Server Error:", error.response.status);
				}
				else if (error.request) {
					console.error("Network Error:", error.request);
				}
				else {
					console.error("Error:", error.message);
				}

				return failureFromError(error);
			});
	}
	catch (e) {
		return {
			error: true,
			success: false,
			message: "Something went wrong. Please try again."
		};
	}
};
